module.exports = "/assets/efe0731259571793dc70d15b248dfb86.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/W2.png
// module id = 3064
// module chunks = 0